import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

type ContributionSuccessDialogProps = {
    open: boolean;
    closeCallback: () => void;
}

export default function ContributionSuccessDialog(props: ContributionSuccessDialogProps) {
  const handleClose = () => {
    props.closeCallback();
  };

  return (
      <Dialog
        open={props.open}
        onClose={handleClose}
      >
        <DialogTitle>
          {"Thank you for your contribution"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Our team will review your contribution and map it to the opening tree database shortly. Thank you for helping us.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
  );
}